import UserIcon from "../../assets/img/user-icon.svg";
import useTranslator from "../../hooks/useTranslator";
import { useNavigate } from "react-router-dom";
import { sendUniversalMail } from "../../services/sharedService";
import { useContext, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import TenantContext from "../../context/tenant/TenantContext";
import DeleteConfiration from "./DeleteConfiration";
import { getGuarantorStatus, toast } from "../../helper/common";
import { BsThreeDotsVertical } from "react-icons/bs";

const EditConfirmationPrompt = DeleteConfiration;

const PendingGuarantorPills = ({
  userData,
  llShowOnly,
  isDropdown,
  setIsDropdown,
  readOnly = false,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const [resendRequestLoading, setResendRequestLoading] = useState(false);
  const { loadUser } = useContext(AuthContext);
  const { removeGuarantor, updateBasicGuarantorAccount } =
    useContext(TenantContext);
  const [showDeleteConfirmationPrompt, setShowDeleteConfirmationPrompt] =
    useState(false);
  const [showEditConfirmationPrompt, setShowEditConfirmationPrompt] =
    useState(false);
  const [deleteGuarantorLoading, setDeleteGuarantorLoading] = useState(false);
  const [editGuarantorLoading, setEditGuarantorLoading] = useState(false);
  const guarantor = userData?.guarantor_id;
  const hasIdentityDetails = Boolean(
    guarantor?.dni_nie || guarantor?.passport_id || guarantor?.identity_number
  );

  const handleCompleteOnboarding = () => {
    navigate(`/guarantor/onboarding?guarantor_a_id=${userData?._id}`);
  };

  const openEditForm = (formType) => {
    navigate(
      `/guarantor/onboarding?guarantor_a_id=${userData?._id}&action=edit&form=${formType}`
    );
  };

  const handleEditDetails = async (formType) => {
    try {
      setEditGuarantorLoading(true);
      await updateBasicGuarantorAccount({
        guarantor_id: userData?._id,
        fname: guarantor?.fname ?? "",
        lname: guarantor?.lname ?? "",
        email: guarantor?.email ?? "",
        gurantor_relation: userData?.gurantor_relation ?? "",
        step: 1,
      });
      setShowEditConfirmationPrompt(false);
      openEditForm(formType);
    } catch (err) {
      toast.error(_t("failedToUpdateGuarantor"));
    } finally {
      setEditGuarantorLoading(false);
    }
  };

  const sendMail = async (receiverEmail, emailType) => {
    let payload = {
      receiverEmail: receiverEmail,
      senderId: localStorage.getItem("saveduserid"),
      emailType: emailType,
      status: "processing",
      guarantorRequestId: userData?._id,
    };
    await sendUniversalMail(payload)
      .then((res) => {
        toast.success(_t("emailSent"));
      })
      .catch((err) => {
        toast.error(_t("errorSendingMail"));
        console.log(err);
      });
  };

  const handleResendGuarantorRequest = async () => {
    try {
      setResendRequestLoading(true);
      await sendMail(userData?.guarantor_id?.email, "score");
    } catch (err) {
      console.log("Error resend guarantor request");
    } finally {
      setResendRequestLoading(false);
    }
  };

  const deleteGuarantor = async (guarantorId, guarantorRequestId) => {
    try {
      setDeleteGuarantorLoading(true);
      await removeGuarantor(guarantorId, guarantorRequestId);
      loadUser("tenant");
      setShowDeleteConfirmationPrompt(false);
    } catch (err) {
      toast.error(_t("failedToDeleteGuarantor"));
    } finally {
      setDeleteGuarantorLoading(false);
    }
  };

  return (
    <>
      <div
        className={`earner-card pending-guarantor-card ${
          llShowOnly ? "custom-mb-2" : ""
        }`}
        onClick={() => setIsDropdown(false)}
      >
        <div className="earner-info guarantor-info align-items-center justify-content-between gap-2 d-flex">
          <div className="align-items-center gap-2 d-flex">
            <div className="earner-thumbnail-wrapper">
              <img src={UserIcon} alt="User Icon" />
            </div>
            <div className="d-flex flex-column">
              <h4 className="earner-name">
                {`${userData?.guarantor_id?.fname ?? ""} ${
                  userData?.guarantor_id?.lname ?? ""
                }`}
              </h4>
              <p className="earner-email">
                {userData?.guarantor_id?.email ?? ""}
              </p>
            </div>
          </div>
          <div
            className="cursor-pointer"
            onClick={(e) => {
              if (readOnly) return;
              e.stopPropagation();
              setIsDropdown(!isDropdown);
            }}
          >
            {!llShowOnly && !readOnly && (
              <BsThreeDotsVertical className="btnSv" />
            )}
          </div>
        </div>
        <div className="position-relative">
          {isDropdown && !llShowOnly && !readOnly && (
            <div className="editDeleteDropdown">
              {userData?.status == "pending" && (
                <p
                  onClick={handleCompleteOnboarding}
                  className="custom-gap-2 text-wraping"
                >
                  <img src="/images/complete-edit.svg" alt="" />
                  {_t("completeAdding")}
                </p>
              )}
              {(userData?.status == "processing" ||
                userData?.status == "present") && (
                <>
                  {userData?.created_guarantor_account === true && (
                    <p
                      onClick={() => {
                        setIsDropdown(false);
                        setShowEditConfirmationPrompt(true);
                      }}
                      className="custom-gap-2 text-wraping"
                    >
                      <img src="/images/complete-edit.svg" alt="" />
                      {_t("editDetails")}
                    </p>
                  )}
                  <p
                    onClick={
                      resendRequestLoading
                        ? () => {}
                        : () => {
                            setIsDropdown(false);
                            handleResendGuarantorRequest();
                          }
                    }
                    className="custom-gap-2 text-wraping"
                  >
                    <img src="/images/send-req.svg" alt="" />
                    {_t("resendRequest")}
                  </p>
                </>
              )}
              <p
                onClick={() => {
                  setIsDropdown(false);
                  setShowDeleteConfirmationPrompt(true);
                }}
                className="deleteText custom-gap-2 text-wraping"
              >
                <img src="/images/delete-icon.svg" alt="" />
                {_t("delete")}
              </p>
            </div>
          )}
        </div>
        {(() => {
          const statusData = getGuarantorStatus(
            userData?.status,
            userData?.guarantor_id
          );
          return (
            <div
              style={{
                ...statusData.style,
              }}
              className={`viewMorebtn status-tile viewMorebtn2 ${
                !llShowOnly ? "" : ""
              }`}
            >
              <p style={{ color: statusData.style.color }}>
                {_t(statusData?.status)}
              </p>

              {statusData?.pendingFrom && (
                <p
                  style={{ color: statusData.style.color2 }}
                  className="d-flex align-items-center"
                >
                  <span
                    style={{ backgroundColor: statusData.style.color2 }}
                    className="status-dot"
                  ></span>
                  {_t(statusData?.pendingFrom)}
                </p>
              )}
            </div>
          );
        })()}
      </div>
      <EditConfirmationPrompt
        isOpen={showEditConfirmationPrompt}
        onClose={() => setShowEditConfirmationPrompt(false)}
        name={
          `${userData?.guarantor_id?.fname ?? ""} ${
            userData?.guarantor_id?.lname ?? ""
          }` ?? ""
        }
        relation={userData?.gurantor_relation ?? ""}
        heading={_t("editDetails")}
        description={_t(
          "editingTheseDetailsWillCancelTheCurrentGuarantorRequest"
        )}
        btn1Text={hasIdentityDetails ? _t("cancel") : _t("editInviteDetails")}
        btn2Text={
          hasIdentityDetails
            ? _t("continue")
            : _t(
                "iCompleteTheProfileMyself",
                "Opens the full guarantor profile form for the tenant to complete"
              )
        }
        btn1Functionality={
          hasIdentityDetails
            ? () => setShowEditConfirmationPrompt(false)
            : () => handleEditDetails("compact")
        }
        btn2Functionality={() => handleEditDetails("full")}
        submitLoading={editGuarantorLoading}
      />
      <DeleteConfiration
        isOpen={showDeleteConfirmationPrompt}
        onClose={() => setShowDeleteConfirmationPrompt(false)}
        name={
          `${userData?.guarantor_id?.fname ?? ""} ${
            userData?.guarantor_id?.lname ?? ""
          }` ?? ""
        }
        relation={userData?.gurantor_relation ?? ""}
        heading={_t("deleteGuarantor")}
        description={_t("areYouSureDoYouWantToDeleteThisGuarantor")}
        btn1Text={_t("noGoBack")}
        btn2Text={_t("yesDelete")}
        btn1Functionality={() => setShowDeleteConfirmationPrompt(false)}
        btn2Functionality={() =>
          deleteGuarantor(userData?.guarantor_id?._id, userData?._id)
        }
        submitLoading={deleteGuarantorLoading}
      />
    </>
  );
};

export default PendingGuarantorPills;
